// v0 = session unique active. Placeholder pour multi-session post-Phase 1+.

interface Props {
  sessionId: string | null;
}

export function ConversationList({ sessionId }: Props) {
  return (
    <aside className="cw-conversations">
      <h2 className="cw-conversations__title">conversations</h2>
      <ul className="cw-conversations__list">
        <li className="cw-conversations__item cw-conversations__item--active">
          <span className="cw-conversations__label">session courante</span>
          <span className="cw-conversations__id">{sessionId ? sessionId.slice(0, 8) : "—"}</span>
        </li>
      </ul>
    </aside>
  );
}
